import { render, staticRenderFns } from "./work-reminder.vue?vue&type=template&id=3831d61b&scoped=true"
import script from "./work-reminder.vue?vue&type=script&lang=ts"
export * from "./work-reminder.vue?vue&type=script&lang=ts"
import style0 from "./work-reminder.vue?vue&type=style&index=0&id=3831d61b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3831d61b",
  null
  
)

export default component.exports